import React, { Component } from "react";
import SVG from "react-inlinesvg";
import { NavLink, withRouter, Link } from "react-router-dom";
import { Dropdown, DropdownButton } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logOutUser } from "../../../store/actions/authAction";
import isEmpty from "../../../store/validation/is-Empty";
import { get_all_notifications } from "../../../store/actions/notificationActions";
import { VENDOR_SCREEN_ID } from "../../../enums/RoleEnum";
import QrScanGlobal from "../../reusableComponents/QrScanGlobal/QrScanGlobal";

export class BottomNavigationMobile extends Component {
  constructor(props) {
    super();
    this.state = {
      pathname: "",
      errors: {},
      showMenuDrawer: false,
      showReports: false,
      showMore: true,
      notificationsCount: 0,
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(
        nextProps.history &&
        nextProps.history.location &&
        nextProps.history.location.pathname
      ) !== nextState.pathname ||
      !nextState.hasSetDataUpdate
    ) {
      return {
        notificationsCount: !isEmpty(nextProps?.auth?.notificationsCount)
          ? nextProps?.auth?.notificationsCount?.total_count
          : 0,
      };
    }
  }
  componentDidMount() {
    let location = this.props.history && this.props.history.location;
    if (location && !this.state.hasSetUpdate) {
      this.setState({
        pathname: location.pathname,
        hasSetUpdate: true,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let location = prevProps.history && prevProps.history.location;
    if (location && !this.state.hasSetUpdate) {
      this.setState({
        pathname: location.pathname,
        hasSetUpdate: true,
      });
    }
  }
  onLogoutClick = (e) => {
    e.preventDefault();
    this.props.logOutUser();
  };
  handleMenuShow = () => {
    this.setState({
      showMenuDrawer: !this.state.showMenuDrawer,
    });
  };
  handlereports = () => {
    this.setState({
      showReports: !this.state.showReports,
      showMore: !this.state.showMore,
    });
  };
  render() {
    let pending = !isEmpty(
      this.props.notification && this.props.notification.pending
    )
      ? this.props.notification.pending
      : [];
    let reservation = !isEmpty(
      this.props.notification && this.props.notification.reservation
    )
      ? this.props.notification.reservation
      : [];
    let walkin = !isEmpty(
      this.props.notification && this.props.notification.walkins
    )
      ? this.props.notification.walkins
      : [];
    let totalUnreadCount = pending.concat(reservation).concat(walkin);
    totalUnreadCount = totalUnreadCount.filter(
      (data) => data.readStatus === false
    ).length;

    const pathname = window.location.pathname;
    return (
      <React.Fragment>
        <ul className="enMobileBottomMenu navigation-order-list vendorMenu">
          <li
            className={`position-relative`}
          >
            <NavLink
              exact
              to="/notification"
              className="dropdown-toggle btn btn-link"
            >
              <SVG
                src={require("../../../assets/images/Menu/vendor/1.svg")}
                className="navigation-icon"
                alt="navigation logo"
              />

              <span className="badge bg-danger text-white position-absolute" style={{top:"3px",right:"-4px"}}>
                {/* {totalUnreadCount} */}
                {this.state?.notificationsCount}
              </span>
            </NavLink>
          </li>
          {this.props.subscriptionData?.casual_dining_status?.seating.value ||
          this.props.subscriptionData?.multi_service_business_status?.seating
            .value ? (
            // &&
            // (this.props?.vendorAccess?.screenID?.includes(
            //   VENDOR_SCREEN_ID.SEATING
            // ) ||
            //   this.props?.vendorAccess?.screenID?.includes("ALL") ||
            //   this.state.vendor)
            <li
              className={`${
                pathname &&
                (pathname === "/seatingdashboard" ||
                  pathname === "/pendingdashboard" ||
                  pathname === "/reservationdashboard" ||
                  pathname === "/historydashboard")
                  ? "selectedmobile"
                  : ""
              }`}
            >
              <NavLink
                exact
                to="/pendingdashboard"
                className="dropdown-toggle btn btn-link"
              >
                <SVG
                  src={require("../../../assets/images/Menu/vendor/2.svg")}
                  className="navigation-icon"
                  alt="seating logo"
                />
              </NavLink>
            </li>
          ) : null}

          <li
            className={`${
              window?.location?.pathname
                ?.toString()
                .includes("itemavailablitydashboard")
                ? "selectedmobile"
                : ""
            }`}
          >
            <NavLink
              exact
              to="/itemavailablitydashboard"
              className="dropdown-toggle btn btn-link"
            >
              <SVG
                src={require("../../../assets/images/Menu/vendor/3.svg")}
                className="navigation-icon"
                alt="logo"
              />
            </NavLink>
          </li>

          <QrScanGlobal mobile={true} />
          <li
            className={`${
              pathname && pathname === "/orderdashboard" ? "selectedmobile" : ""
            }`}
          >
            <NavLink
              exact
              to="/orderdashboard"
              className="dropdown-toggle btn btn-link"
            >
              <SVG
                src={require("../../../assets/images/Menu/vendor/4.svg")}
                className="navigation-icon"
                alt="logo"
              />
            </NavLink>
          </li>
          <li
            className={`dropright ${
              pathname && pathname === "/offers"
                ? "selectedmobile"
                : "" || pathname === "/event"
                ? "selectedmobile"
                : "" ||
                //  pathname === "/reportdashboard"
                // ? "selected"
                // : "" ||
                 pathname === "/vendorreviews"
                ? "selectedmobile"
                : "" || pathname === "/profile "
                ? "selectedmobile"
                : "" ||
                  // || pathname === "/customerbusiness"
                  // ? "selected"
                  // : ""
                  pathname === "/vendoruseropenissues"
                ? "selectedmobile"
                : "" || pathname === "/vendoropensuggestionissues"
                ? "selectedmobile"
                : "" || pathname === "/rolemanagement"
                ? "selectedmobile"
                : "" || this.state.showMenuDrawer
                ? "selectedmobile"
                : ""
            }`}
          >
            <button
              type="button"
              className="dropdown-toggle btn btn-link"
              onClick={this.handleMenuShow}
            >
              <SVG
                src={require("../../../assets/images/Menu/vendor/5.svg")}
                className="navigation-icon"
                alt="Icon"
              />
            </button>
          </li>
        </ul>
        {this.state.showMenuDrawer && (
          <div className="mobileBottomMenuDrawer align-items-center justify-content-center">
            <div className="w-100 text-center py-2">
              <button
                type="button"
                className="btn btn-link"
                onClick={this.handleMenuShow}
              >
                <SVG
                  src={require("../../../assets/images/UserManagement/up-arrow-red.svg")}
                  alt="Icon"
                  width="20px"
                  height="20px"
                />
              </button>
            </div>
            {/* {this.state.showMore && (
              <> */}
            <Dropdown.Item
              as={Link}
              to="/offer"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/offer" ? "selected" : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/Menu/vandorGridMenu/1.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Offers</div>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/curatedDashboard"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/event" ? "selected" : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/Menu/vandorGridMenu/2.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Experience</div>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/reportdashboard"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/reportdashboard" ? "selected" : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/Menu/vandorGridMenu/3.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Reports</div>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/vendorreviews"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/vendorreviews" ? "selected" : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/Menu/vandorGridMenu/4.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Ratings</div>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/profile"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/profile" ? "selected" : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/Menu/vandorGridMenu/5.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Profile</div>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/customerbusiness"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/customerbusiness" ? "selected" : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/Menu/vandorGridMenu/6.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Settings</div>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/vendoruseropenissues"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/vendoruseropenissues"
                  ? "selected"
                  : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/Menu/vandorGridMenu/7.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Open Tickets</div>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/vendoropensuggestionissues"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/vendoropensuggestionissues"
                  ? "selected"
                  : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/Menu/vandorGridMenu/8.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Open Issues</div>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/rolemanagement"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/rolemanagement" ? "selected" : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/Menu/vandorGridMenu/9.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Role</div>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/" ? "selected" : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/Menu/vandorGridMenu/10.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Staff</div>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/referrals"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/referrals" ? "selected" : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/Menu/vandorGridMenu/8.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Referrals</div>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/paymentactivityreports"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray p-2 ${
                pathname && pathname === "/paymentactivityreports"
                  ? "selected"
                  : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/leftNav/tag.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Payment Activity</div>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/memolist"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/memolist" ? "selected" : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/Menu/vandorGridMenu/5.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Memos</div>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/earnings"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/earnings" ? "selected" : ""
              }`}
            >
              <SVG
                src={require("../../../assets/images/Menu/vandorGridMenu/5.svg")}
                alt="Icon"
              />
              <div className="f9-500 pt-1">Earnings</div>
            </Dropdown.Item>
            <Dropdown.Item
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray`}
            >
              <button
                type="submit"
                className="logout-mobile"
                onClick={this.handlereports}
              >
                <SVG
                  src={require("../../../assets/images/leftNav/reportsnew.svg")}
                  alt="Icon"
                />
                <div className="f9-500 pt-1">Reports</div>
              </button>
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/"
              className={`d-flex align-items-center f14_500_HelveticaNeue text-gray ${
                pathname && pathname === "/" ? "selected" : ""
              }`}
            >
              <button
                type="submit"
                className="logout-mobile"
                onClick={this.onLogoutClick}
              >
                <SVG
                  src={require("../../../assets/images/Menu/vandorGridMenu/logout.svg")}
                  alt="Icon"
                />
                <div className="f9-500 pt-1">Logout</div>
              </button>
            </Dropdown.Item>

            {/* </>
            )} */}
            {this.state.showReports && (
              <>
                <div className="d-flex w-100">
                  <p className="f20-700 ml-2">Reports</p>
                </div>
                <div
                  className="w-100 align-items-center justify-content-center"
                  style={{ display: "contents" }}
                >
                  <Dropdown.Item
                    as={Link}
                    to="/offervendorreports"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/Menu/reportMenu/4.svg")}
                      alt="Icon"
                    />
                    Offer
                    <br />
                    Reports
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/Eventreports"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/Menu/reportMenu/2.svg")}
                      alt="Icon"
                    />
                    Event
                    <br />
                    Reports
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/itemreports"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/Menu/reportMenu/4.svg")}
                      alt="Icon"
                    />
                    Items
                    <br />
                    Reports
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/categoryreports"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/Menu/reportMenu/4.svg")}
                      alt="Icon"
                    />
                    Category
                    <br />
                    Reports
                  </Dropdown.Item>
                </div>
                <div className="d-flex w-100">
                  <p className="f20-700 ml-2">Seating</p>
                </div>
                <div
                  className="w-100 align-items-center  text-center"
                  style={{ display: "flex" }}
                >
                  <Dropdown.Item
                    as={Link}
                    to="/pendingseatingorder"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                      alt="Icon"
                      style={{
                        width: "25px",
                        height: "25px",
                      }}
                    />
                    Seating Pending
                    <br /> Activity Report
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/allseatingreports"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/seatingImages/seatingGray.svg")}
                      alt="Icon"
                      style={{
                        width: "25px",
                        height: "25px",
                      }}
                    />
                    All Seating
                    <br /> Report
                  </Dropdown.Item>
                </div>
                <div className="d-flex w-100">
                  <p className="f20-700 ml-2">Ordering</p>
                </div>
                <div
                  className="w-100 align-items-center justify-content-center text-center"
                  style={{ display: "contents" }}
                >
                  <Dropdown.Item
                    as={Link}
                    to="/allorderreport"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/leftNav/event.svg")}
                      alt="Icon"
                    />
                    All Order
                    <br /> Report
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/ordertaxreport"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/leftNav/event.svg")}
                      alt="Icon"
                    />
                    Order Tax <br /> Report
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/orderitem-sale-and-taxreport"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/leftNav/event.svg")}
                      alt="Icon"
                    />
                    Order Item <br />
                    Sales & Tax Report
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/orderrefundcancellationreport"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/leftNav/event.svg")}
                      alt="Icon"
                    />
                    Order
                    <br /> Refund &<br /> Cancellation Report
                  </Dropdown.Item>
                </div>
                <div className="d-flex w-100">
                  <p className="f20-700 ml-2">Settlements</p>
                </div>
                <div
                  className="w-100 align-items-center justify-content-center text-center"
                  style={{ display: "contents" }}
                >
                  <Dropdown.Item
                    as={Link}
                    to="/mainsettlementsvendor"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/leftNav/tag.svg")}
                      alt="Icon"
                    />
                    Settlements
                    <br /> Report
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/merchantStatement"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/leftNav/tag.svg")}
                      alt="Icon"
                    />
                    Merchant <br /> Statement
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/scanandpayreport"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/leftNav/tag.svg")}
                      alt="Icon"
                    />
                    Scan & Pay
                    <br /> Report
                  </Dropdown.Item>
                  <br />
                  <div className="d-flex w-100"></div>
                  <Dropdown.Item
                    as={Link}
                    to="/invoicereport"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/leftNav/tag.svg")}
                      alt="Icon"
                    />
                    Invoice
                    <br /> Report
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/referalreport"
                    className="d-flex align-items-center f14_500_HelveticaNeue text-gray"
                  >
                    <SVG
                      src={require("../../../assets/images/Menu/reportMenu/1.svg")}
                      alt="Icon"
                    />
                    Referral
                    <br />
                    Reports
                  </Dropdown.Item>
                </div>
              </>
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}
// BottomNavigationMobile.propTypes = {
//   logOutUser: PropTypes.func.isRequired,
//   notification: PropTypes.object.isRequired,
//   auth: PropTypes.object.isRequired,
//   errors: PropTypes.object.isRequired,
// };

const mapStateToProps = (state) => ({
  notification: state.notifications,
  auth: state.auth,
  errors: state.errors.errors,
  subscriptionData: state.onboarding.onboard_subscription_details,
  vendorAccess: state.vendorAccess,
});

export default connect(mapStateToProps, { logOutUser, get_all_notifications })(
  withRouter(BottomNavigationMobile)
);

// import React, { Component } from "react";
// import "react-responsive-modal/styles.css";
// import { Modal } from "react-responsive-modal";
// import Container from "react-bootstrap/Container";
// import Row from "react-bootstrap/Row";
// import { NavLink } from "react-router-dom";
// import Image from "react-bootstrap/Image";

// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
// import { clear_all_errors } from "../../../store/actions/errorActions";
// import { logOutUser } from "../../../store/actions/authAction";

// export class BottomNavigationMobile extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       open: false,
//       buttonClick: "seats",
//     };
//   }

//   componentDidMount() {
//     this.props.clear_all_errors();
//   }

//   onLogoutClick = (e) => {
//     e.preventDefault();
//     this.props.logOutUser();
//   };

//   onOpenModal = () => {
//     this.setState({ open: true });
//   };

//   onCloseModal = () => {
//     this.setState({ open: false });
//   };

//   /***************************
//    * @DESC on Button Handler
//    ***************************/
//   onButtonClick = (e, type) => {
//     e.preventDefault();
//     this.setState({
//       buttonClick: type,
//     });
//   };

//   render() {
//     const { open } = this.state;
//     return (
//       <React.Fragment>
//         <Container fluid>
//           <div className="bottom-main-navigation">
//             <Row className="text-center align-items-center">
//               <div className="col">
//                 <NavLink
//                   to="/seatingdashboard"
//                   className="text-decoration-none"
//                 >
//                   <Image
//                     src={require("../../../assets/images/ActionImages/darkChair.png")}
//                     fluid
//                     alt="Seats"
//                     title="Seating Dashboard"
//                     className="image-seating"
//                   />
//                   <p className="seats-icon-text">Seats</p>
//                 </NavLink>
//               </div>
//               <div className="col">
//                 <NavLink to="/notification" className="text-decoration-none">
//                   <Image
//                     src={require("../../../assets/images/ActionImages/ring.svg")}
//                     fluid
//                     alt="Seats"
//                     title="Seating Dashboard"
//                     className="image-seating-notification"
//                   />
//                   <p className="notification-icon-text">Notification</p>
//                 </NavLink>
//               </div>
//               <div className="col">
//                 <i
//                   className="fa fa-bars hamburgur-class"
//                   aria-hidden="true"
//                   onClick={this.onOpenModal}
//                 ></i>
//                 <Modal
//                   open={open}
//                   onClose={this.onCloseModal}
//                   center
//                   classNames={{
//                     overlay: "customOverlay-request-accept-cancelled",
//                     modal: "bottom-mobile-navigation",
//                     closeButton: "customCloseButton",
//                     animationIn: "customEnterAnimation",
//                     animationOut: "customLeaveAnimation",
//                   }}
//                   animationDuration={1000}
//                 >
//                   <div>
//                     <h4>Kathakali Restaurant - Seattle </h4>
//                     <hr />
//                     <div className="navigation-link">
//                       <NavLink
//                         to="/seatingdashboard"
//                         className="inside-popup-navigation"
//                       >
//                         <Image
//                           src={require("../../../assets/images/ActionImages/seatingIcon.png")}
//                           fluid
//                           alt="Seats"
//                           title="Seating Dashboard"
//                           className="inside-popup-image"
//                         />
//                         <p className="inside-popup-text">Seating</p>
//                       </NavLink>
//                       <NavLink to="/offer" className="inside-popup-navigation">
//                         <Image
//                           src={require("../../../assets/images/ActionImages/tag.svg")}
//                           fluid
//                           alt="Seats"
//                           title="Seating Dashboard"
//                           className="inside-popup-image"
//                         />
//                         <p className="inside-popup-text">Offers</p>
//                       </NavLink>
//                       <NavLink to="/event" className="inside-popup-navigation">
//                         <Image
//                           src={require("../../../assets/images/ActionImages/event.svg")}
//                           fluid
//                           alt="Seats"
//                           title="Seating Dashboard"
//                           className="inside-popup-image"
//                         />
//                         <p className="inside-popup-text">Event</p>
//                       </NavLink>
//                       <NavLink
//                         to="/editprofile"
//                         className="inside-popup-navigation"
//                       >
//                         <Image
//                           src={require("../../../assets/images/ActionImages/userProfile.png")}
//                           fluid
//                           alt="Seats"
//                           title="Seating Dashboard"
//                           className="inside-popup-image"
//                         />
//                         <p className="inside-popup-text">Profile</p>
//                       </NavLink>
//                       <NavLink
//                         to="/reportdashboard"
//                         className="inside-popup-navigation"
//                         onClick={(e) =>
//                           (window.location.href = "/reportdashboard")
//                         }
//                       >
//                         <Image
//                           src={require("../../../assets/images/ActionImages/reports.png")}
//                           fluid
//                           alt="Seats"
//                           title="Seating Dashboard"
//                           className="inside-popup-image"
//                         />
//                         <p className="inside-popup-text">Reports</p>
//                       </NavLink>
//                       <NavLink
//                         to="/customerbusiness"
//                         onClick={(e) =>
//                           (window.location.href = "/customerbusiness")
//                         }
//                         className="inside-popup-navigation"
//                       >
//                         <Image
//                           src={require("../../../assets/images/ActionImages/reports.png")}
//                           fluid
//                           alt="Seats"
//                           title="Seating Dashboard"
//                           className="inside-popup-image"
//                         />
//                         <p className="inside-popup-text">Settings</p>
//                       </NavLink>
//                       <NavLink
//                         to="/mapsetup"
//                         onClick={(e) => (window.location.href = "/mapsetup")}
//                         className="inside-popup-navigation"
//                       >
//                         <Image
//                           src={require("../../../assets/images/ActionImages/reports.png")}
//                           fluid
//                           alt="Seats"
//                           title="Seating Dashboard"
//                           className="inside-popup-image"
//                         />
//                         <p className="inside-popup-text">Onboarding Process</p>
//                       </NavLink>
//                     </div>
//                     <div className="bottom-text-navigation-icon">
//                       <div className="col-12 d-flex justify-content-between">
//                         <h3>Version 3.1.94 b10210</h3>
//                         <button
//                           type="submit"
//                           className="button-logout-mobile"
//                           onClick={this.onLogoutClick}
//                         >
//                           Logout
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </Modal>
//               </div>
//             </Row>
//           </div>
//         </Container>
//       </React.Fragment>
//     );
//   }
// }

// BottomNavigationMobile.propTypes = {
//   logOutUser: PropTypes.func.isRequired,
//   auth: PropTypes.object.isRequired,
//   errors: PropTypes.object.isRequired,
// };

// const mapStateToProps = (state) => ({
//   auth: state.auth,
//   errors: state.errors.errors,
// });

// export default connect(mapStateToProps, { clear_all_errors, logOutUser })(
//   withRouter(BottomNavigationMobile)
// );
